import _ from "lodash";

function TextareaComponent(props) {
	const { id, label, readonly, required, uiSchema, placeholder, onChange, value } = props;
	let classNames = _.get(uiSchema, 'ui:options.classNames');

	return (
		<div className={classNames}>
			<label htmlFor={id}>{label}{required && '*'}</label>
			<div className="input-group">
				<textarea
					id={id}
					placeholder={placeholder}
					rows="5"
					className="form-control"
					onBlur={(e) => {
						onChange(e.target.value)
					}}
					readOnly={readonly}
					defaultValue={value}
				/>
			</div>
		</div>
	)
}

export default TextareaComponent;

